<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Default Backup Times'"
       />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <form [formGroup]="form" novalidate action="#">
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'If my Pro can\'t make the time I booked, automatically find a new time for my job at one of these times:'" />
        </tidy-row>
        <tidy-card>
          @for (day of checkedBkpDays; track day; let i = $index) {
            <ng-container formArrayName="days">
              <ng-container [formGroupName]="i">
                <tidy-checkbox
                  [items]="[{viewValue: (i | tweekday), value: true}]"
                  formControlName="checked"
                  [checked]="getWeekdayFormGroup(i).controls.checked.value"
                  (checkedChange)="checkboxChange($event, i)" />
                <tidy-row class="field-top-padding">
                  @if (getWeekdayFormGroup(i).controls.checked.value) {
                    <tidy-two-column-row>
                      <tidy-select
                        style="flex: 1;"
                        [icon]="'assets/svg/time.svg'"
                        [label]="'Time'"
                        [form]="getWeekdayFormGroup(i).controls.start_time"
                        formControlName="start_time"
                        (optionChange)="startTimeChange($event, i)"
                        [items]="startTimeOpts" />
                      <tidy-text
                        [body]="'to'"
                        style="line-height: 65px; text-align: center; min-width: 40px; display: flex; justify-content: center; align-items: center;"
                        [ngStyle]="{'margin-left': windowService.isDesktopRes ? '8px' : '3px'}" />
                      <tidy-select
                        style="flex: 1;"
                        [icon]="'assets/svg/time.svg'"
                        [label]="'Time'"
                        [form]="getWeekdayFormGroup(i).controls.end_time"
                        formControlName="end_time"
                        [listedItems]="endTimeOpts.filter(endTimesFilter.bind(this, i))" />
                    </tidy-two-column-row>
                  }
                </tidy-row>
              </ng-container>
            </ng-container>
          }
        </tidy-card>
        <tidy-error-message [text]="errorMessage" />
        <tidy-button
          [text]="'Save Changes'"
          [action]="boundSaveChanges"
          class="primary" />
      </form>
    }
  </tidy-wrapper>
</ng-template>


@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
